import React from 'react';

import { ButtonColour } from 'components/Button/constants';
import { getLink } from 'modules/utils/utils';
import { KeyTemplatesItemIcon } from './KeyTemplatesItemIcon';
import { ResourceHubItemType } from 'components/FeaturedResources/types';
import CtaButton from 'components/Cta/Button';

import styles from './styles.module.scss';
import { InformationCard } from 'components/CMSModals/informationcard';
import { RESOURCE_HUB_URL } from 'modules/utils/constants';

type KeyTemplatesItemProp = {
  keyTemplate: InformationCard;
};

export const KeyTemplatesItem: React.FunctionComponent<KeyTemplatesItemProp> =
  ({ keyTemplate }) => {
    return (
      <li className={styles.keyTemplatesItem}>
        <KeyTemplatesItemIcon contentType={'reports'} />
        <div>
          {keyTemplate.title && <p>{keyTemplate.title}</p>}
          <span>{keyTemplate.information}</span>
        </div>
        <div>
          <CtaButton
            ariaLabel={keyTemplate.title?.substring(0, 30)}
            colour={ButtonColour.BRAND_MONO_ONE}
            page_link={`${RESOURCE_HUB_URL}${keyTemplate?.icon}`}
            onClick={() => {
              localStorage.setItem('contentRowKey', keyTemplate.contentRowKey);
            }}
            small
          />
        </div>
      </li>
    );
  };

export default KeyTemplatesItem;
